import React from 'react';
import {
  HeaderTableRow,
  StyledTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
} from './actionPlanList.styled';
import { Body5, Headline5 } from '../../../../app/common/typography';
import {
  IActionPlanList,
  IActionPlanTable,
} from '../../../../app/@types/actionPlanList';
import { DisplayUserName } from '../../../../helpers/convertName';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { useNavigate } from 'react-router-dom';
import { getItem } from '../../../../utils/localStorage';
import { ActionPlanListType } from '../../../../enums/ActionPlanListType';
import { useTranslation } from 'react-i18next';
import { Event } from '../../../../enums/labels/Event';
import { DateFormatEnum, formatDate } from '../../../../helpers/dates';

export function ActionPlanTable ({
  tableData,
  viewType,
  updateSorting,
  actionPlanListType,
  fetchTableData,
  hasMore,
}: IActionPlanTable) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  function actionPlanClickHandler (actionPlan: IActionPlanList) {
    if (actionPlanListType === ActionPlanListType.series) {
      const selectedAssessmentId = getItem('selectedAssessmentId');
      navigate(
        `/actionPlansSeries/${viewType}/${selectedAssessmentId}/${actionPlan.parentId || actionPlan.id}/${actionPlan.id}`
      );
    } else {
      navigate(`/editActionPlan/from-individual/${viewType}/${actionPlan.id}`, {
        state: { level: 5 },
      });
    }
  }

  function displayActionListUserName (actionPlan) {
    if (actionPlanListType === ActionPlanListType.series) {
      return actionPlan.seriesParentName;
    } else if (viewType === Event.sent) {
      return DisplayUserName(actionPlan.actionPlanUsers ? actionPlan.actionPlanUsers[0] : actionPlan.assigned);
    } else {
      return DisplayUserName(actionPlan.owner);
    }
  }

  return (
    <TableContainer>
      <InfiniteScroll
        dataLength={tableData.length}
        next={fetchTableData}
        hasMore={hasMore}
        loader={<LoadingContent layout="flex" />}
      >
        <StyledTable>
          <TableHead>
            <HeaderTableRow>
              <TableHeader>
                <Headline5 onClick={() => updateSorting('id')}>
                  {actionPlanListType === ActionPlanListType.individual &&
                  viewType === Event.sent
                    ? t('COMMON.ACTION_PLAN.LABEL.SENT_TO')
                    : t('COMMON.ACTION_PLAN.LABEL.CREATED_BY')}
                </Headline5>
              </TableHeader>
              <TableHeader>
                <Headline5 onClick={() => updateSorting('actionRequired')}>
                  {t('COMMON.ACTION_PLAN.LIST_HEADER.ACTION_REQUIRED')}
                </Headline5>
              </TableHeader>
              <TableHeader>
                <Headline5 onClick={() => updateSorting('deadline')}>
                  {t('COMMON.ACTION_PLAN.LIST_HEADER.DUE_DATE')}
                </Headline5>
              </TableHeader>
              <TableHeader>
                <Headline5 onClick={() => updateSorting('completedStatus')}>
                  {t('COMMON.ACTION_PLAN.LIST_HEADER.COMPLETE')}
                </Headline5>
              </TableHeader>
            </HeaderTableRow>
          </TableHead>
          <TableBody>
            {tableData.map((actionPlan) => {
              return (
                <TableRow
                  onClick={() => actionPlanClickHandler(actionPlan)}
                  key={actionPlan.id}
                >
                  <TableCell>
                    <Body5>{displayActionListUserName(actionPlan)}</Body5>
                  </TableCell>
                  <TableCell>
                    {actionPlan.actionRequired ? (
                      <Body5 color="redCrayola">Y</Body5>
                    ) : (
                      <Body5 color="verdigrisDark">N</Body5>
                    )}
                  </TableCell>
                  <TableCell>
                    <Body5>
                      {formatDate(actionPlan.deadline, DateFormatEnum.ddmmyy)}
                    </Body5>
                  </TableCell>
                  <TableCell>
                    <Body5>
                      {moment(actionPlan.deadline) >
                      moment().subtract(1, 'days') ? (
                        <Body5 color="verdigrisDark">
                          {actionPlan.completedStatus}/
                          {actionPlan.totalActionPlan}
                        </Body5>
                      ) : (
                        <Body5 color="redCrayola">
                          {actionPlan.completedStatus}/
                          {actionPlan.totalActionPlan}
                        </Body5>
                      )}
                    </Body5>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </StyledTable>
      </InfiniteScroll>
    </TableContainer>
  );
}
